import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const schoolClips = [
  { id: 'h01', city: '北京', school: '北京四中', img: 'https://public.readdy.ai/ai/img_res/d4bc66cdc3beb3805513200e84355609.jpg' },
  { id: 'h02', city: '云南昭通', school: '昭通一中', img: 'https://readdy.ai/api/search-image?query=Chinese%20teenage%20girl%20student%20reading%20book%20in%20rural%20Yunnan%20school%20library%2C%20school%20uniform%2C%20warm%20natural%20light%2C%20wooden%20desk%2C%20sincere%20expression%2C%20realistic%20school%20photo&width=300&height=200&seq=hero_c02&orientation=landscape' },
  { id: 'h03', city: '上海', school: '上海中学', img: 'https://readdy.ai/api/search-image?query=Chinese%20teenage%20boy%20student%20working%20on%20physics%20experiment%20in%20modern%20Shanghai%20school%20lab%2C%20school%20uniform%2C%20concentrated%20look%2C%20science%20equipment%2C%20bright%20lab%2C%20realistic%20school%20photo&width=300&height=200&seq=hero_c03&orientation=landscape' },
  { id: 'h04', city: '甘肃定西', school: '定西一中', img: 'https://readdy.ai/api/search-image?query=Chinese%20teenage%20girl%20student%20writing%20in%20notebook%20at%20simple%20rural%20Gansu%20school%20classroom%2C%20school%20uniform%2C%20diligent%20expression%2C%20afternoon%20sunlight%2C%20modest%20classroom%2C%20realistic%20school%20photo&width=300&height=200&seq=hero_c04&orientation=landscape' },
  { id: 'h05', city: '广州', school: '执信中学', img: 'https://readdy.ai/api/search-image?query=Chinese%20teenage%20boy%20studying%20chemistry%20at%20modern%20Guangzhou%20school%20desk%2C%20school%20uniform%2C%20bright%20smile%2C%20periodic%20table%20poster%20on%20wall%2C%20well-equipped%20classroom%2C%20realistic%20school%20photo&width=300&height=200&seq=hero_c05&orientation=landscape' },
  { id: 'h06', city: '贵州黔东南', school: '凯里一中', img: 'https://readdy.ai/api/search-image?query=Chinese%20teenage%20girl%20reading%20biology%20textbook%20in%20Guizhou%20rural%20school%20classroom%2C%20school%20uniform%2C%20happy%20expression%2C%20green%20plants%20outside%20window%2C%20simple%20tidy%20classroom%2C%20realistic%20school%20photo&width=300&height=200&seq=hero_c06&orientation=landscape' },
  { id: 'h07', city: '成都', school: '成都七中', img: 'https://readdy.ai/api/search-image?query=Chinese%20teenage%20boy%20reviewing%20history%20notes%20in%20Chengdu%20school%20study%20room%2C%20school%20uniform%2C%20friendly%20expression%2C%20bookshelves%20behind%2C%20warm%20indoor%20lighting%2C%20realistic%20school%20photo&width=300&height=200&seq=hero_c07&orientation=landscape' },
  { id: 'h08', city: '西藏拉萨', school: '拉萨一中', img: 'https://readdy.ai/api/search-image?query=young%20Tibetan%20teenage%20boy%20student%20studying%20geography%20with%20map%20in%20Lhasa%20school%20classroom%2C%20school%20uniform%2C%20warm%20smile%2C%20bright%20classroom%2C%20realistic%20school%20photo&width=300&height=200&seq=hero_c08&orientation=landscape' },
  { id: 'h09', city: '杭州', school: '学军中学', img: 'https://readdy.ai/api/search-image?query=Chinese%20teenage%20girl%20coding%20on%20computer%20in%20Hangzhou%20school%20computer%20lab%2C%20school%20uniform%2C%20cheerful%20expression%2C%20multiple%20monitors%2C%20modern%20tech%20classroom%2C%20realistic%20school%20photo&width=300&height=200&seq=hero_c09&orientation=landscape' },
  { id: 'h10', city: '宁夏固原', school: '固原一中', img: 'https://readdy.ai/api/search-image?query=Chinese%20teenage%20girl%20solving%20math%20problems%20at%20desk%20in%20Ningxia%20rural%20school%2C%20school%20uniform%2C%20focused%20expression%2C%20chalk%20blackboard%20in%20background%2C%20simple%20classroom%2C%20realistic%20school%20photo&width=300&height=200&seq=hero_c10&orientation=landscape' },
  { id: 'h11', city: '深圳', school: '深圳中学', img: 'https://readdy.ai/api/search-image?query=Chinese%20teenage%20boy%20practicing%20English%20speech%20in%20modern%20Shenzhen%20school%20auditorium%2C%20school%20uniform%2C%20confident%20posture%2C%20bright%20stage%20lighting%2C%20realistic%20school%20photo&width=300&height=200&seq=hero_c11&orientation=landscape' },
  { id: 'h12', city: '内蒙古', school: '海拉尔一中', img: 'https://readdy.ai/api/search-image?query=Chinese%20Mongolian%20teenage%20girl%20writing%20essay%20in%20Inner%20Mongolia%20school%20classroom%2C%20school%20uniform%2C%20grassland%20scenery%20visible%20through%20window%2C%20warm%20expression%2C%20wooden%20desk%2C%20realistic%20school%20photo&width=300&height=200&seq=hero_c12&orientation=landscape' },
];

// Tree stages: right (tiny) → left (big), 4 stages
const trees = [
  {
    // Stage 4 — rightmost: tiny seedling
    delay: '0s',
    trunk: { w: 4, h: 12 },
    crowns: [{ w: 20, h: 14, opacity: 0.22 }],
    left: 'right-[22%]',
  },
  {
    // Stage 3 — small sapling
    delay: '0.3s',
    trunk: { w: 6, h: 28 },
    crowns: [
      { w: 36, h: 22, opacity: 0.25 },
      { w: 52, h: 28, opacity: 0.28 },
    ],
    left: 'right-[14%]',
  },
  {
    // Stage 2 — medium tree
    delay: '0.6s',
    trunk: { w: 10, h: 52 },
    crowns: [
      { w: 48, h: 30, opacity: 0.28 },
      { w: 72, h: 40, opacity: 0.32 },
      { w: 96, h: 48, opacity: 0.30 },
    ],
    left: 'right-[6%]',
  },
  {
    // Stage 1 — leftmost: big tree
    delay: '0.9s',
    trunk: { w: 16, h: 88 },
    crowns: [
      { w: 64, h: 38, opacity: 0.30 },
      { w: 96, h: 52, opacity: 0.35 },
      { w: 128, h: 64, opacity: 0.38 },
      { w: 160, h: 72, opacity: 0.32 },
    ],
    left: 'right-[0%]',
  },
];

export default function HeroSection() {
  const [activeIdx, setActiveIdx] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIdx((prev) => (prev + 1) % schoolClips.length);
    }, 2000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative min-h-screen flex flex-col justify-center overflow-hidden bg-gradient-to-br from-amber-700 via-yellow-600 to-amber-800">

      {/* Keyframe styles */}
      <style>{`
        @keyframes growUp {
          0%   { transform: scaleY(0); opacity: 0; transform-origin: bottom center; }
          60%  { opacity: 1; }
          100% { transform: scaleY(1); opacity: 1; transform-origin: bottom center; }
        }
        @keyframes crownBloom {
          0%   { transform: scale(0); opacity: 0; }
          70%  { opacity: 1; }
          100% { transform: scale(1); opacity: 1; }
        }
        @keyframes floatPetal {
          0%,100% { transform: translateY(0px) rotate(0deg); opacity: 0.6; }
          50%      { transform: translateY(-12px) rotate(15deg); opacity: 1; }
        }
        .tree-trunk { animation: growUp 1.4s cubic-bezier(.22,1,.36,1) both; }
        .tree-crown { animation: crownBloom 1.2s cubic-bezier(.22,1,.36,1) both; }
        .petal      { animation: floatPetal 3s ease-in-out infinite; }
      `}</style>

      {/* Background blobs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-32 -left-32 w-96 h-96 bg-yellow-400/20 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 -left-20 w-72 h-72 bg-amber-300/20 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-20 left-1/4 w-80 h-80 bg-yellow-500/15 rounded-full blur-3xl"></div>
        <div className="absolute top-20 right-1/3 w-64 h-64 bg-amber-200/15 rounded-full blur-3xl"></div>

        {/* Animated trees — right (tiny) to left (big) */}
        {trees.map((tree, ti) => (
          <div
            key={ti}
            className={`absolute bottom-0 ${tree.left} flex flex-col items-center`}
            style={{ animationDelay: tree.delay }}
          >
            {/* Crowns — bloom from top down */}
            <div className="flex flex-col items-center">
              {tree.crowns.map((c, ci) => (
                <div
                  key={ci}
                  className="tree-crown rounded-full blur-sm"
                  style={{
                    width: c.w,
                    height: c.h,
                    backgroundColor: `rgba(251,191,36,${c.opacity})`,
                    marginTop: ci > 0 ? -Math.floor(c.h * 0.35) : 0,
                    animationDelay: `${parseFloat(tree.delay) + ci * 0.15}s`,
                  }}
                ></div>
              ))}
            </div>
            {/* Trunk — grows upward */}
            <div
              className="tree-trunk rounded-full mx-auto"
              style={{
                width: tree.trunk.w,
                height: tree.trunk.h,
                backgroundColor: 'rgba(120,53,15,0.55)',
                animationDelay: tree.delay,
              }}
            ></div>
          </div>
        ))}

        {/* Pink petals / flowers floating */}
        {[
          { bottom: '18%', right: '23%', size: 10, delay: '0s' },
          { bottom: '28%', right: '16%', size: 8, delay: '0.8s' },
          { bottom: '12%', right: '10%', size: 12, delay: '1.4s' },
          { bottom: '22%', right: '4%',  size: 7, delay: '0.4s' },
          { bottom: '35%', right: '20%', size: 6, delay: '1.8s' },
          { bottom: '8%',  right: '18%', size: 9, delay: '1.1s' },
        ].map((p, i) => (
          <div
            key={i}
            className="petal absolute rounded-full"
            style={{
              bottom: p.bottom,
              right: p.right,
              width: p.size,
              height: p.size,
              backgroundColor: `rgba(251,191,36,0.55)`,
              animationDelay: p.delay,
              filter: 'blur(1px)',
            }}
          ></div>
        ))}

        {/* Floating sparkle particles */}
        {[
          { top: '15%', left: '5%', size: 6, color: 'rgba(251,191,36,0.4)', delay: '0s' },
          { top: '30%', left: '12%', size: 4, color: 'rgba(253,230,138,0.4)', delay: '0.5s' },
          { top: '50%', left: '8%', size: 8, color: 'rgba(251,191,36,0.3)', delay: '1s' },
          { top: '20%', left: '18%', size: 4, color: 'rgba(253,230,138,0.35)', delay: '1.5s' },
          { top: '65%', left: '15%', size: 6, color: 'rgba(251,191,36,0.35)', delay: '0.7s' },
        ].map((p, i) => (
          <div
            key={i}
            className="petal absolute rounded-full"
            style={{
              top: p.top,
              left: p.left,
              width: p.size,
              height: p.size,
              backgroundColor: p.color,
              animationDelay: p.delay,
              filter: 'blur(1px)',
            }}
          ></div>
        ))}
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 pt-24 pb-16 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center min-h-[80vh]">

          {/* Left: Text */}
          <div className="flex flex-col justify-center">
            <div className="inline-flex items-center gap-2 bg-amber-500/20 border border-amber-400/40 rounded-full px-4 py-1.5 mb-6 w-fit">
              <i className="ri-seedling-line text-amber-400 text-sm"></i>
              <span className="text-amber-300 text-sm font-medium">一位父亲的心愿 · 千万孩子的未来</span>
            </div>

            <h1 className="text-4xl md:text-6xl font-black text-white leading-tight mb-5">
              金榜旺财
              <br />
              <span className="text-amber-400 text-2xl md:text-3xl font-bold">高考·考研升学平台</span>
              <br />
              <span className="text-3xl md:text-5xl">让每一个孩子</span>
              <br />
              <span className="text-amber-400">都能金榜题名</span>
            </h1>

            <div className="border-l-2 border-amber-400/60 pl-4 mb-6">
              <p className="text-white/80 text-sm leading-relaxed">
                打造这一卓越平台的初衷，源于一位出身乡村的超级富豪父亲。他自幼刻苦求学，最终获得了名牌大学的博士学位，并成功创办了多家杰出企业。如今，这位富豪育有三个子女，孩子们平时也会花些时间玩游戏。为了引导这些在城市长大的孩子懂得珍惜学习时光，<strong className="text-amber-300">他们需要结识一些来自乡村的朋友</strong>——城乡孩子取长补短，共同进步。
              </p>
            </div>

            <div className="flex flex-wrap gap-2 mb-8">
              {[
                { icon: 'ri-heart-line', text: '城市孩子学会感恩' },
                { icon: 'ri-global-line', text: '乡村孩子走向世界' },
                { icon: 'ri-team-line', text: '跨越地域共同成长' },
              ].map((v) => (
                <div key={v.text} className="flex items-center gap-1.5 bg-white/10 border border-white/20 rounded-full px-3.5 py-1.5">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${v.icon} text-amber-300 text-xs`}></i>
                  </div>
                  <span className="text-white/90 text-xs font-medium">{v.text}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap gap-6 mb-10">
              {[
                { num: '50万+', label: '注册学生' },
                { num: '2万+', label: '教学视频' },
                { num: '8000+', label: '优秀教师' },
                { num: '98%', label: '升学率' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl font-black text-amber-400">{stat.num}</div>
                  <div className="text-white/60 text-xs mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap gap-4">
              <Link to="/videos" className="px-8 py-3.5 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-full transition-all cursor-pointer whitespace-nowrap flex items-center gap-2">
                <i className="ri-play-circle-line"></i>开始学习
              </Link>
              <Link to="/community" className="px-8 py-3.5 bg-white/15 hover:bg-white/25 border border-white/40 text-white font-semibold rounded-full transition-all cursor-pointer whitespace-nowrap flex items-center gap-2">
                <i className="ri-team-line"></i>寻找学伴
              </Link>
            </div>
          </div>

          {/* Right: 12-clip school photo mosaic */}
          <div className="hidden lg:block">
            <div className="grid grid-cols-3 grid-rows-4 gap-2 h-[580px]">
              {schoolClips.map((clip, idx) => (
                <div
                  key={clip.id}
                  className={`relative rounded-xl overflow-hidden cursor-pointer transition-all duration-500 ${
                    activeIdx === idx ? 'ring-2 ring-amber-400 scale-[1.03]' : 'opacity-80 hover:opacity-100'
                  }`}
                  onClick={() => setActiveIdx(idx)}
                >
                  <img src={clip.img} alt={`${clip.city} ${clip.school}`} className="w-full h-full object-cover object-top" />
                  <div className={`absolute inset-0 transition-all duration-500 ${activeIdx === idx ? 'bg-black/10' : 'bg-black/35'}`}></div>
                  <div className={`absolute bottom-0 left-0 right-0 px-2 py-1.5 transition-all duration-300 ${activeIdx === idx ? 'opacity-100' : 'opacity-0'}`}>
                    <div className="bg-black/60 rounded-lg px-2 py-1">
                      <p className="text-white text-[10px] font-bold leading-tight">{clip.city}</p>
                      <p className="text-white/60 text-[9px] leading-tight">{clip.school}</p>
                    </div>
                  </div>
                  {activeIdx === idx && (
                    <div className="absolute top-2 right-2 w-5 h-5 flex items-center justify-center bg-amber-400 rounded-full">
                      <i className="ri-play-fill text-white text-[9px]"></i>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div className="mt-3 flex items-center gap-3 bg-white/10 border border-white/15 rounded-xl px-4 py-2.5">
              <div className="w-2 h-2 bg-amber-400 rounded-full animate-pulse"></div>
              <div className="flex-1">
                <span className="text-white text-xs font-semibold">{schoolClips[activeIdx].city}</span>
                <span className="text-white/50 text-xs mx-2">·</span>
                <span className="text-white/70 text-xs">{schoolClips[activeIdx].school}</span>
              </div>
              <span className="text-white/40 text-xs">{activeIdx + 1} / {schoolClips.length}</span>
            </div>
          </div>

        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 animate-bounce">
        <span className="text-white/40 text-xs">向下探索</span>
        <i className="ri-arrow-down-line text-white/40"></i>
      </div>
    </section>
  );
}
